export default {
	name: "indexView",
	data() {
		return {
			accordionVal: 0,
			specialList: [],
			courseList: [],
		};
	},
	watch: {},
	async mounted() {
		await this.getCourseList();
	},
	onUpdated() {},
	beforeDestroy() {},
	methods: {
		async getCourseList() {
			const listRes = await this.$zkHttp.index$get_my_special({
				user_id: this.$store.state.auth.user_id,
				order_id: ""
			});
			console.log("listRes ===> ", listRes);
			this.specialList = listRes;
		},
		async onSpecChange(e) {
			console.log("onSpecChange => ", e);
			this.accordionVal = e;
			if (this.accordionVal) {
				const listRes = await this.$zkHttp.index$get_user_course({
					user_id: this.$store.state.auth.user_id,
					special_id: this.accordionVal
				});
				console.log("listRes ===> ", listRes);
				if (listRes) {
					this.courseList = listRes;
					// #ifdef MP
					this.$nextTick(() => {
						this.$refs.accordion.resize()
					})
					// #endif
				}
			}
		},
		toCourseDetail(co) {
			this.$router.push({
				name: 'courseDetail',
				query: {
					parent: 'home',
					course_id: co.course_id
				}
			});
		},
		toMyPage(page) {
			this.$router.push(`/${page}`);
		},
	},
};